import React from 'react'

export default () => (
  <div>
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="36" cy="36" r="36" fill="black" fillOpacity="0.5" />
      <path
        d="M48.3297 35.1808L28.5735 21.3514C27.9107 20.8875 27 21.3616 27 22.1707V49.8293C27 50.6384 27.9107 51.1125 28.5735 50.6486L48.3297 36.8192C48.8984 36.4211 48.8984 35.5789 48.3297 35.1808Z"
        fill="white"
      />
    </svg>
  </div>
)
